import { fetchAllCourses, fetchFeaturedCourses, fetchPopularCourses, fetchCategories, fetchAllCoursesWithPromotions } from "./courseService";

let preloadPromise: Promise<void> | null = null;

/**
 * Preload critical course data on app initialization
 * This runs in the background and caches the results
 */
export async function preloadCriticalData(): Promise<void> {
  if (preloadPromise) return preloadPromise;

  preloadPromise = (async () => {
    try {
      // Preload all course queries in parallel
      await Promise.all([
        fetchFeaturedCourses(),
        fetchPopularCourses(),
        fetchAllCourses(),
        fetchCategories(),
        fetchAllCoursesWithPromotions(),
      ]);
      
      console.log("✅ Critical course data preloaded and cached");
    } catch (error) {
      console.error("❌ Failed to preload critical data:", error);
    }
  })();

  return preloadPromise;
}

/**
 * Check if critical data has been preloaded
 */
export function isDataPreloaded(): boolean {
  return preloadPromise !== null;
}
